import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { CharlieConfirmProvider } from '@ver.id/libs.ui.charlie';
import { apolloClient } from './apollo';
import App from './App';
import { I18nProvider } from './i18n/i18n';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <ApolloProvider client={apolloClient}>
    <I18nProvider>
      <ErrorBoundary>
        <CharlieConfirmProvider>
          <App />
        </CharlieConfirmProvider>
      </ErrorBoundary>
    </I18nProvider>
  </ApolloProvider>,
);
